export default "__VITE_ASSET__c0766212__"